import axios from "axios";
// import Cookies from "js-cookie";

export default {
    getAxiosConfig(queryParams = {}) {
        // axios.get(process.env.VUE_APP_BASE_URI + '/csrf').then(({ data }) => {
        //     window.axios.defaults.headers.common['X-CSRF-TOKEN'] = data;

        // axios.defaults.headers.common = {
        // "X-Requested-With": "XMLHttpRequest"
        // };
        // axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        // axios.defaults.headers.common['X-CSRF-TOKEN'] = document.getElementById('csrf');

        // axios.defaults.headers.common["Authorization"] = Cookies.set(
        //     "access_token"
        // );
        return {
            // withCredentials: true,
            params: queryParams
        };
        // })
    },

    get(link, queryParams = {}) {
        return axios.get(
            process.env.VUE_APP_API + link,
            this.getAxiosConfig(queryParams)
        );
    },

    post(link, data = {}, queryParams = {}) {
        return axios.post(
            process.env.VUE_APP_API + link,
            data,
            this.getAxiosConfig(queryParams)
        );
    },

    put(link, data = {}, queryParams = {}) {
        return axios.put(
            process.env.VUE_APP_API + link,
            data,
            this.getAxiosConfig(queryParams)
        );
    },

    delete(link, queryParams = {}) {
        return axios.delete(
            process.env.VUE_APP_API + link,
            this.getAxiosConfig(queryParams)
        );
    }
};
